import { buildModelManager } from "../builder.js";
const DefaultCustomerSelection = {
  __typename: true,
  id: true,
  abandonedCartCampaignId: true,
  abandonedCartDelayInMinutes: true,
  abandonedCartDiscountInPercents: true,
  alcmeonCompanyId: true,
  alcmeonSecret: true,
  alcmeonSiteId: true,
  apiKey360Dialog: true,
  apiKeyBrevo: true,
  apiKeyEasiware: true,
  apiKeyGorgias: true,
  apiKeyHubspot: true,
  apiKeySimio: true,
  apiKeySplio: true,
  apiKeyZendesk: true,
  automaticReplyNodeId: true,
  automaticUtm: true,
  awayMessage: true,
  azureTenantId: true,
  backInStockCampaignId: true,
  backInStockDeliveryIntervalInMinutes: true,
  backInStockNotificationRate: true,
  boughtConversations: true,
  campaignsDataSpreadsheetUrl: true,
  channelId360Dialog: true,
  channelIdEasiware: true,
  clientId360Dialog: true,
  codeForAlcmeon: true,
  codeForLogin: true,
  confirmationUrl: true,
  copilotAiConfigurationId: true,
  createdAt: true,
  crispWebsiteId: true,
  customFields: true,
  emailsForNotifications: true,
  eventClickUrlHubspot: true,
  gaiaCustomDatasourceId: true,
  gaiaShopifyDatasourceId: true,
  gaiaWebsiteDatasourceId: true,
  gaiaWebsiteDatasources: true,
  globalVariables: true,
  gorgiasUserId: true,
  hasInvoiceToPay: true,
  hostEasiware: true,
  hostGorgias: true,
  hostZendesk: true,
  hoursForAttribution: true,
  invoiceToPayAmountInUSD: true,
  invoiceToPayName: true,
  is2faActivated: true,
  isAutomaticUtmActivated: true,
  isAwayMessageActivated: true,
  isCloudApi: true,
  isExportCampaignsDataGoogleSheetActivated: true,
  isExternalTurnoverSplioActivated: true,
  isGaiaActivated: true,
  isOrderConfirmationCampaignActive: true,
  isOrderTrackingCampaignActive: true,
  isOwnAiActivated: true,
  isSalesAiActivated: true,
  isStripeMetricNumberOfSendings: true,
  isStripeSubscribed: true,
  isSubscribed: true,
  klaviyoAccessToken: true,
  klaviyoAccessTokenExpiry: true,
  klaviyoCodeVerifier: true,
  klaviyoOptinSegmentId: true,
  klaviyoRefreshToken: true,
  klaviyoToken: true,
  lastCheckPaymentMethodAt: true,
  lastExportedCampaignsDataToGoogleSheetDate: true,
  lastMessageFailedForPaymentIssueAt: true,
  limitMarketingPressure: true,
  messagingLimit: true,
  name: true,
  onboardingProgress: true,
  openingHours: true,
  optinConfirmationCampaignId: true,
  optinFieldBrevo: true,
  optinFieldHubspot: true,
  optinsOffset: true,
  orderConfirmationCampaignId: true,
  orderConfirmationCampaignWithoutOptinId: true,
  orderTrackingCampaignId: true,
  phoneNumber: true,
  phoneNumberId: true,
  quality: true,
  remainingConversations: true,
  restrictionDate: true,
  restrictionInfo: true,
  salesAiEndHour: true,
  salesAiOffDays: true,
  salesAiPrompt: true,
  salesAiStartHour: true,
  sendOptinConfirmationCampaignOnlyToNewCustomers: true,
  sendOrderConfirmationCampaignToEveryone: true,
  sendingRatePerMinute: true,
  sftpHost: true,
  sftpPassword: true,
  sftpPort: true,
  sftpUploadDirectory: true,
  sftpUsername: true,
  shopId: true,
  shopifyShopId: true,
  shouldEncryptPI: true,
  shouldHidePersonalData: true,
  shouldOptoutInAppOptouts: true,
  shouldPostponeMessages: true,
  shouldPreventAutomations: true,
  shouldPreventMultipleAutoReplySendings: true,
  stripeCheckoutSessionId: true,
  stripeCustomerId: true,
  stripeFreeTrialDays: true,
  stripeOptinsPriceId: true,
  stripeSubscriptionPriceId: true,
  updatedAt: true,
  violationType: true,
  waAccessToken: true,
  wabaId: true,
  wabaId360Dialog: true,
  whatsappEmbeddedSignupToken: true,
  whatsappOrderNodeId: true,
  whatsappPhoneNumberId: true,
  whatsappToken: true
};
const modelApiIdentifier = "customer";
const pluralModelApiIdentifier = "customers";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByWhatsappPhoneNumberId",
    findByField: "whatsappPhoneNumberId",
    findByVariableName: "whatsappPhoneNumberId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByWhatsappPhoneNumberId",
    findByField: "whatsappPhoneNumberId",
    findByVariableName: "whatsappPhoneNumberId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByApiKeySimio",
    findByField: "apiKeySimio",
    findByVariableName: "apiKeySimio",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByApiKeySimio",
    findByField: "apiKeySimio",
    findByVariableName: "apiKeySimio",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByKlaviyoToken",
    findByField: "klaviyoToken",
    findByVariableName: "klaviyoToken",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByKlaviyoToken",
    findByField: "klaviyoToken",
    findByVariableName: "klaviyoToken",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByShopifyShopId",
    findByField: "shopifyShopId",
    findByVariableName: "shopifyShopId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByShopifyShopId",
    findByField: "shopifyShopId",
    findByVariableName: "shopifyShopId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCustomer",
    operationReturnType: "CreateCustomer",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { customer: { required: false, type: "CreateCustomerInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCustomers",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateCustomersInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "action",
    operationName: "updateCustomer",
    operationReturnType: "UpdateCustomer",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      customer: { required: false, type: "UpdateCustomerInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCustomers",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateCustomersInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "action",
    operationName: "deleteCustomer",
    operationReturnType: "DeleteCustomer",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCustomers",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCustomer",
    operationReturnType: "UpsertCustomer",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      customer: { required: false, type: "UpsertCustomerInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCustomerResult": { hasReturnType: false },
      "... on UpdateCustomerResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCustomers",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertCustomersInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCustomerSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "customerGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CustomerManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCustomerSelection,
  operations
);
export {
  CustomerManager,
  DefaultCustomerSelection
};
//# sourceMappingURL=Customer.js.map
